import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShortcutEnter = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "-0.80882 -0.80882 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0.441176 5.29412H7.05882C7.54613 5.29412 7.94118 4.89908 7.94118 4.41177V1.32353C7.94118 0.83622 7.54613 0.441176 7.05882 0.441176H4.41176",
		stroke: "currentColor",
		strokeWidth: .882353,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M3.08824 2.64706L0.441176 5.29412L3.08824 7.94118",
		stroke: "currentColor",
		strokeWidth: .882353,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgShortcutEnter;
